import React from 'react';
import { Switch, FormControl, InputLabel, FormControlLabel, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  input: {
    display: 'flex',
    '& > label': {
      overflow: 'hidden',
      position: 'relative',
      transform: 'none',
      alignItems: 'center',
      display: 'flex',
      color: '#414141',
      paddingTop: (props) => (props.multiline ? theme.spacing(0.85) : 0),
    },
  },
  inline: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    '& > label': {
      position: 'relative',
      transform: 'none',
      alignItems: 'center',
      display: 'flex',
      width: (props) => (props.labelSize ? `${props.labelSize}px` : '200px'),
      color: '#414141',
    },
    '& .MuiSwitch-root': {
      height: 30,
      padding: 9,
      '& .MuiSwitch-switchBase': {
        top: -1,
        padding: 5,
        '&.Mui-checked': {
          transform: 'translateX(28px)',
        },
      },
    },
  },
}));

const MySwitch = React.forwardRef((props, ref) => {
  const { label, inline, readOnly, checked, showText = false, bold = true, ...rest } = props;
  const _ref = ref || props.inputRef || props.innerRef;
  const classes = useStyles();
  const { t } = useTranslation();

  const inputValue = checked ? t('ACTIVE') : t('INACTIVE');

  if (inline) {
    return (
      <FormControl fullWidth className={clsx(classes.input, classes.inline)}>
        <InputLabel className={clsx(bold && 'font-bold')}>{label}</InputLabel>
        {!readOnly && <Switch checked={checked} color="primary" {...rest} ref={_ref} />}
        {(readOnly || showText) && <Typography component="span">{inputValue}</Typography>}
      </FormControl>
    );
  }

  return (
    <FormControlLabel
      control={<Switch checked={checked} color="primary" {...rest} ref={_ref} />}
      label={label}
      labelPlacement="start"
    />
  );
});

export default MySwitch;
